import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

class DefaultDataCell extends PureComponent {
  static propTypes = {
    className: PropTypes.string,
    emptyValue: PropTypes.string,
    value: PropTypes.string
  };

  static defaultProps = {
    className: "",
    emptyValue: "-",
    value: ""
  };

  state = {
    isContentVisible: false
  };

  maybeOverflowedRef = React.createRef();

  handleToggleIsContentVisible = () => {
    if (this.maybeOverflowedRef.current.offsetWidth + 1 < this.maybeOverflowedRef.current.scrollWidth) {
      this.setState({ isContentVisible: !this.state.isContentVisible });
    }
  };

  render() {
    return (
      <div
        role="cell"
        className={classNames("data-grid__data", this.props.className)}
        onMouseEnter={this.handleToggleIsContentVisible}
        onMouseLeave={this.handleToggleIsContentVisible}
        ref={this.maybeOverflowedRef}>
        {this.props.value ? this.props.value : this.props.emptyValue}
        {this.state.isContentVisible && <span className="list-popover__content">{this.props.value}</span>}
      </div>
    );
  }
}

export default DefaultDataCell;



// WEBPACK FOOTER //
// ./src/components/Layout/DataGrid/DefaultDataCell.js